import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, switchMap } from 'rxjs';
import { FormGroup, UntypedFormControl } from '@angular/forms';
import {
    SharedModule,
    CustomDetailComponent,
    GetSellerDetailQuery,
    DataService,
    ModalService,
    NotificationService,
    FormInputComponent,
    StringCustomFieldConfig,
} from '@vendure/admin-ui/core';
import { safeJSONParse } from '../utils';
import { ProductVariantMetaData } from '../ui-types';


@Component({
    template: `
    <div>
        <vdr-form-field [label]="'Enabled'" class="mb-2">
            <clr-toggle-wrapper>
                <input
                    type="checkbox"
                    clrToggle
                    name="enabled"
                    [formControl]="enabledControl"
                />
            </clr-toggle-wrapper>
        </vdr-form-field>

        <div *ngIf="enabledControl.value">
            <select [formControl]="dataTypeControl">
              <option value="" disabled>Select Product Customization Type</option>
              <option value="printing-template">Custom Print</option>
            </select>
            <vdr-card *ngIf="dataTypeControl.value === 'printing-template'" class="mt-2">
                <vdr-form-field [label]="'Template'" class="mb-2">
                    <vdr-dynamic-form-input
                        [control]="patternControl"
                        [def]="{
                            type: 'text',
                            ui: {
                                component: 'pattern-editor-input-form',
                            }
                        }"
                    >
                    </vdr-dynamic-form-input>
                </vdr-form-field>
            </vdr-card>
        </div>
    </div>
    `,
    standalone: true,
    imports: [SharedModule],
    styles: []
})

export class ProductOptionMetaDataFormComponent implements FormInputComponent<StringCustomFieldConfig>, OnInit, AfterViewInit {
    readonly: boolean;
    config: StringCustomFieldConfig;
    formControl: UntypedFormControl;
    enabledControl = new UntypedFormControl();
    dataTypeControl = new UntypedFormControl();
    patternControl = new UntypedFormControl();
    initialLoaded = false;

    constructor(
        private notificationService: NotificationService,
    ) {}

    ngOnInit() {
        if (this.formControl && this.formControl.value) {
            try {
                const defaultProductMetaData: ProductVariantMetaData = {
                    enabled: false,
                    type: '',
                    content: '',
                };
                const metaData = safeJSONParse<ProductVariantMetaData>(
                    this.formControl.value,
                    this.notificationService,
                    defaultProductMetaData,
                )!;
                if (metaData && metaData.enabled) {
                    this.enabledControl.setValue(true);
                    if (metaData.type) {
                        this.dataTypeControl.setValue(metaData.type);
                    }
                    if (metaData.content) {
                        this.patternControl.setValue(metaData.content);
                    }
                }
            } catch (e) {
                this.enabledControl.setValue(false);
            }
        }
    }

    ngAfterViewInit() {
        this.enabledControl.valueChanges.subscribe(() => this.updateFormValue());
        this.dataTypeControl.valueChanges.subscribe(() => this.updateFormValue());
        this.patternControl.valueChanges.subscribe(() => this.updateFormValue());
    }

    private updateFormValue() {
        if (!this.formControl) return;

        if (!this.enabledControl.value) {
            this.dataTypeControl.setValue('');
            this.formControl.setValue('');
        } else {
            const metaData = {
                enabled: this.enabledControl.value,
                type: this.dataTypeControl.value,
                content: this.patternControl.value,
            };
            this.formControl.setValue(JSON.stringify(metaData));
        }
        if(!this.initialLoaded) {
            this.initialLoaded = true;
        } else {
            this.formControl.markAsDirty();
        }
    }
}